import { AxiosResponse } from 'axios';
import { StatusCodes } from 'http-status-codes';

const is404Response = (response: AxiosResponse) => {
    return response.status === StatusCodes.NOT_FOUND;
};

export default is404Response;
